"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterDefined = void 0;
const omitValues_1 = require("./omitValues");
const filterDefined = (source) => (0, omitValues_1.omitValues)(source, [undefined]);
exports.filterDefined = filterDefined;
//# sourceMappingURL=filterDefined.js.map